<li class="list-group-item d-block py-1" *ngIf="!hide">
    <div class="row w-100 d-flex align-items-center">
        <div class="col">
            <ng-content></ng-content>
        </div>
        <div *ngIf="showVisible" class="col-2">
            <input class="form-check-input checkbox mt-1" type="checkbox" role="checkbox"
                (click)="updatePermissionVisibleConfig($event)"
                [disabled]="permission.isLocked || permission.isDisabled" [checked]="permission.isHidden">
        </div>
        <div *ngIf="showLock" class="col-2">
            <input class="form-check-input checkbox mt-1" type="checkbox" role="checkbox" (click)="updatePermissionLockConfig($event)"
                [disabled]="permission.isDisabled" [checked]="permission.isLocked">
        </div>
        <div *ngIf="showDisabled" class="col-2">
            <input class="form-check-input checkbox mt-1" type="checkbox" role="checkbox"
                (click)="updatePermissionDisableConfig($event)" [checked]="permission.isDisabled">
        </div>
        <div  *ngIf="showForce" class="col-1">
            <button type="button" class="btn btn-sm btn-secondary"(click)="openForceModal()" translate="Button.Force"></button>
        </div>
    </div>
</li>